'use client'

import type { ComponentProps } from 'react'

import { CopyButton } from '@/components/ui/copy-button'
import { track } from '@/lib/analytics/track'

type TrackedCopyButtonProps = ComponentProps<typeof CopyButton> & {
  event: string
  eventProperties?: Record<string, string | number | boolean | null>
}

/** Track intent only after clipboard write succeeds; this is not activation. */
export function TrackedCopyButton({
  event,
  eventProperties,
  ...copyProps
}: TrackedCopyButtonProps) {
  return (
    <CopyButton
      {...copyProps}
      onCopySuccess={() => track(event, eventProperties)}
    />
  )
}
